import { Navigate } from "react-router-dom";
import { checkTokenExpiration } from "../Utils/CheckTokenExpiry";

export const PrivateRoute = ({ element }) => {
    const isAuthenticated = checkTokenExpiration();
    return isAuthenticated ? element : <Navigate to='/Login' replace />;
};

export const ProtectedRoute = ({ children }) => {
    const localStorageToken = localStorage.getItem('token');

    if (localStorageToken) {
        return children;
    }
    else {
        return <Navigate to='/Login' />
    }
}
